import { render, staticRenderFns } from "./TuitionPackage.vue?vue&type=template&id=356153af&"
import script from "./TuitionPackage.vue?vue&type=script&lang=js&"
export * from "./TuitionPackage.vue?vue&type=script&lang=js&"
import style0 from "./TuitionPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports